import React, { Component } from 'react';
import { Link } from "react-router-dom";
import {
    Container,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    CardText,
    Row,
    Col
} from "reactstrap";
import TooltipItem from "../common/TooltipItem";
import { Nav, NavItem, NavLink } from "reactstrap";

class Dashboard2 extends Component {
    state = {};

    render() {
        return (
            <Container className="pt-3">
                <Card className="card" >
                    <CardHeader>
                        <span className="login-view " style={{ fontSize: "1.5rem" }}>
                            <NavLink
                                style={{ paddingTop: "0px" }}
                                id="tooltip1"
                                tag={Link}
                                to="/dashboard"
                                className="nav-color"
                            >
                                <i className="fas fa-home fa-lg" style={{ fontSize: "1.5rem" }} />
                            </NavLink>
                           /     Administrative Settings</span>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col lg="6" md="6">
                                <Link to={'/dashboard2/user-management'}>
                                    <Card className="card my-3 py-3" style={{ backgroundColor: "#eaf1fc" }}>
                                        <CardBody className="text-center">

                                            <CardTitle><i className="fas fa-users fa-4x py-2" /></CardTitle>
                                            <medium>Manage Users</medium>
                                            <CardText>
                                                <small className="text-muted">Manager Users and User Settings</small>
                                            </CardText>
                                        </CardBody>
                                    </Card>
                                </Link>
                            </Col>
                            <Col lg="6" md="6">
                                <Link to={'/dashboard2/application-settings'}>
                                    <Card className="card my-3 py-3" style={{ backgroundColor: "#eaf1fc" }}>
                                        <CardBody className="text-center">
                                            <CardTitle><i className="fas fa-4x fa-cogs py-2" /></CardTitle>
                                            <medium>Application Settings</medium>
                                            <CardText>
                                                <small className="text-muted">Add/Modify Application Settings</small>
                                            </CardText>
                                        </CardBody>
                                    </Card>
                                </Link>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Container>
        );
    }
}

export default Dashboard2;
